// Schedule preferences management for localStorage

export interface SchedulePreferences {
  view: "month" | "week" | "day" | "threeday" | "workweek";
  columnMode: "practitioner" | "day" | "services" | "room" | "day-practitioner";
  displayMode: "calendar" | "list";
  selectedServiceTypes: string[];
  selectedPharmacists: string[];
  selectedRooms: string[];
  selectedBlockOutTypes: string[];
  selectedPharmacies?: string[];
}

const STORAGE_KEY = "schedule_preferences";

export function saveSchedulePreferences(preferences: SchedulePreferences): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch (error) {
    console.error("Failed to save schedule preferences:", error);
  }
}

export function loadSchedulePreferences(): SchedulePreferences | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error("Failed to load schedule preferences:", error);
  }
  return null;
}

export function clearSchedulePreferences(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear schedule preferences:", error);
  }
}

export function hasSchedulePreferences(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== null;
  } catch (error) {
    return false;
  }
}

// API enum mapping helpers
export const mapApiDisplayMode = (mode?: number): "calendar" | "list" => {
  if (mode === 2) return "list";
  return "calendar";
};

export const mapApiViewType = (
  type?: number,
): "month" | "week" | "day" | "threeday" | "workweek" => {
  switch (type) {
    case 1:
      return "day";
    case 2:
      return "threeday";
    case 3:
      return "workweek";
    case 4:
      return "week";
    case 5:
      return "month";
    default:
      return "workweek";
  }
};

export const mapApiGroupBy = (
  groupBy?: number,
): "practitioner" | "day" | "services" | "room" | "day-practitioner" => {
  switch (groupBy) {
    case 1:
      return "practitioner";
    case 2:
      return "day";
    case 3:
      return "day-practitioner";
    case 4:
      return "services";
    case 5:
      return "room";
    default:
      return "day-practitioner";
  }
};

export const displayModeToApiMap: Record<string, number> = {
  calendar: 1,
  list: 2,
};

export const viewTypeToApiMap: Record<string, number> = {
  day: 1,
  threeday: 2,
  workweek: 3,
  week: 4,
  month: 5,
};

export const groupByToApiMap: Record<string, number> = {
  practitioner: 1,
  day: 2,
  "day-practitioner": 3,
  services: 4,
  room: 5,
};
